// import authHeader from "../Auth/authHeader";
// import axios from "axios";
// import { ApiLink } from "../APILink/ApiLink";
// import { errorAlert } from "../Components/Alerts";

// const headers = authHeader();

// // Funksioni për të ekzekutuar printerin fiskal pa u shfaqur si komponent
// export const executeTermolPrinter = async (data, invoiceNr) => {
//   const getVATClass = (vatRate) => {
//     if (vatRate === 18) return "E";
//     if (vatRate === 8) return "D";
//     if (vatRate === 0) return "A";
//     return "X"; // Vlerë default nëse nuk përputhet
//   };

//   const generateXml = () => {
//     let xmlData = `<Command Name="settings">
//           <Args>
//             <Arg Name="com" Value="COM1" />
//             <Arg Name="baud" Value="115200" />
//           </Args>
//         </Command>
//         <Command Name="OpenReceipt">
//           <Args>
//             <Arg Name="OperNum" Value="1" />
//             <Arg Name="OperPass" Value="0" />
//           </Args>
//         </Command>`;

//     data.forEach((item) => {
//       const vatClass = getVATClass(item.VATRates);
//       xmlData += `
//         <Command Name="SellPLUwithSpecifiedVAT">
//         <Args>
//                    <Arg Name="NamePLU" Value="${item.ArticleName}" />
//                    <Arg Name="OptionVATClass" Value="${vatClass}" />
//                    <Arg Name="Price" Value="${item.PriceWithVAT}" />
//                    <Arg Name="Quantity" Value="${item.QtyOutput}" Compulsory="true" />
//                  </Args>
//         </Command>`;
//     });

//     xmlData += `<Command Name="CashPayCloseReceipt" />`;

//     return xmlData;
//   };

//   // const xmlData = generateXml();

//   const requestData = {
//     xml: generateXml(),
//     invoiceNr: invoiceNr // ✅ Sigurohu që invoiceNr ka vlerë
//   };

//   try {
//     const response = await axios.post(ApiLink.API_URL + "Fiscal/save-xml", requestData, { headers });
//     // console.log("Rezultati nga printeri fiskal:", response.data);
//   } catch (error) {
//     // console.error("Gabim gjatë dërgimit të XML-it:", error);
//     errorAlert("Ndodhi nje gabim gjate shtypjes se kuponit")
//   }
// };



import authHeader from "../Auth/authHeader";
import axios from "axios";
import { ApiLink } from "../APILink/ApiLink";
import { errorAlert } from "../Components/Alerts";

const headers = authHeader();

export const executeTermolPrinter = async (data, invoiceNr) => {
  const getVATClass = (vatRate) => {
    if (vatRate === 18) return "E";
    if (vatRate === 8) return "D";
    if (vatRate === 0) return "A";
    return "X"; // Vlerë default nëse nuk përputhet
  };

  const generateXml = () => {
    let xmlData = `<Command Name="settings">
          <Args>
            <Arg Name="com" Value="COM1" />
            <Arg Name="baud" Value="115200" />
          </Args>
        </Command>
        <Command Name="OpenReceipt">
          <Args>
            <Arg Name="OperNum" Value="1" />
            <Arg Name="OperPass" Value="0" />
            <Arg Name="OptionPrintType" Value="">
              <Options>
                <Option Name="Postponed printing" Value="2" />
                <Option Name="Step by step printing" Value="0" />
              </Options>
            </Arg>
          </Args>
       </Command>`;

    data.forEach((item) => {
      const vatClass = getVATClass(item.VATRates);
      xmlData += `
        <Command Name="SellPLUwithSpecifiedVAT">
          <Args>
            <Arg Name="NamePLU" Value="${item.ArticleName}" />
            <Arg Name="OptionVATClass" Value="${vatClass}" />
            <Arg Name="Price" Value="${item.PriceWithVAT}" />
            <Arg Name="Quantity" Value="${item.QtyOutput}" Compulsory="true" />
            <Arg Name="DiscAddP" Value="" Compulsory="false" />
            <Arg Name="DiscAddV" Value="" Compulsory="false" />
            <Arg Name="DepNum" Value="" Compulsory="false" />
          </Args>
        </Command>`;
    });

    xmlData += `\n<Command Name="CashPayCloseReceipt" />`;

    return xmlData;
  };

  const requestData = {
    xml: generateXml(),
    invoiceNr: invoiceNr
  };

  try {
    // ✅ Kërkesa tani do të kthejë një `blob` për shkarkim
    const response = await axios.post(ApiLink.API_URL + "Fiscal/save-xml", requestData, {
      headers,
      responseType: 'blob' // ⬅ Ky është ndryshimi kryesor
    });

    // ✅ Krijo një file XML për shkarkim automatik
    const blob = new Blob([response.data], { type: 'application/xml' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = `file_${invoiceNr}.xml`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    errorAlert("Ndodhi një gabim gjatë shtypjes së kuponit");
  }
};
